/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DocumentDownloadDto } from '../models/document-download-dto';
import { DocumentInfoDto } from '../models/document-info-dto';
import { documentsDownloadDocument } from '../fn/documents/documents-download-document';
import { DocumentsDownloadDocument$Params } from '../fn/documents/documents-download-document';
import { documentsGetDocumentsForCase } from '../fn/documents/documents-get-documents-for-case';
import { DocumentsGetDocumentsForCase$Params } from '../fn/documents/documents-get-documents-for-case';
import { documentsGetDocumentsForPatient } from '../fn/documents/documents-get-documents-for-patient';
import { DocumentsGetDocumentsForPatient$Params } from '../fn/documents/documents-get-documents-for-patient';
import { documentsGetDocumentTypes } from '../fn/documents/documents-get-document-types';
import { DocumentsGetDocumentTypes$Params } from '../fn/documents/documents-get-document-types';
import { documentsUploadDocumentForCase } from '../fn/documents/documents-upload-document-for-case';
import { DocumentsUploadDocumentForCase$Params } from '../fn/documents/documents-upload-document-for-case';
import { DocumentTypeDto } from '../models/document-type-dto';

@Injectable({ providedIn: 'root' })
export class DocumentsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentsGetDocumentTypes()` */
  static readonly DocumentsGetDocumentTypesPath = '/api/documents/types';

  /**
   * Get all allowed document types.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsGetDocumentTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsGetDocumentTypes$Response(params?: DocumentsGetDocumentTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentTypeDto>>> {
    const obs = documentsGetDocumentTypes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all allowed document types.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsGetDocumentTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsGetDocumentTypes(params?: DocumentsGetDocumentTypes$Params, context?: HttpContext): Observable<Array<DocumentTypeDto>> {
    const resp = this.documentsGetDocumentTypes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DocumentTypeDto>>): Array<DocumentTypeDto> => r.body)
    );
  }

  /** Path part for operation `documentsGetDocumentsForCase()` */
  static readonly DocumentsGetDocumentsForCasePath = '/api/documents/case/{casId}';

  /**
   * Get documents for case by casId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsGetDocumentsForCase()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsGetDocumentsForCase$Response(params: DocumentsGetDocumentsForCase$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentInfoDto>>> {
    const obs = documentsGetDocumentsForCase(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get documents for case by casId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsGetDocumentsForCase$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsGetDocumentsForCase(params: DocumentsGetDocumentsForCase$Params, context?: HttpContext): Observable<Array<DocumentInfoDto>> {
    const resp = this.documentsGetDocumentsForCase$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DocumentInfoDto>>): Array<DocumentInfoDto> => r.body)
    );
  }

  /** Path part for operation `documentsUploadDocumentForCase()` */
  static readonly DocumentsUploadDocumentForCasePath = '/api/documents/case/{casId}';

  /**
   * Upload document for a case.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsUploadDocumentForCase()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsUploadDocumentForCase$Response(params: DocumentsUploadDocumentForCase$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentInfoDto>> {
    const obs = documentsUploadDocumentForCase(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Upload document for a case.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsUploadDocumentForCase$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsUploadDocumentForCase(params: DocumentsUploadDocumentForCase$Params, context?: HttpContext): Observable<DocumentInfoDto> {
    const resp = this.documentsUploadDocumentForCase$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DocumentInfoDto>): DocumentInfoDto => r.body)
    );
  }

  /** Path part for operation `documentsGetDocumentsForPatient()` */
  static readonly DocumentsGetDocumentsForPatientPath = '/api/documents/person/{perId}';

  /**
   * Get documents for patient by perId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsGetDocumentsForPatient()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsGetDocumentsForPatient$Response(params: DocumentsGetDocumentsForPatient$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentInfoDto>>> {
    const obs = documentsGetDocumentsForPatient(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get documents for patient by perId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsGetDocumentsForPatient$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsGetDocumentsForPatient(params: DocumentsGetDocumentsForPatient$Params, context?: HttpContext): Observable<Array<DocumentInfoDto>> {
    const resp = this.documentsGetDocumentsForPatient$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DocumentInfoDto>>): Array<DocumentInfoDto> => r.body)
    );
  }

  /** Path part for operation `documentsDownloadDocument()` */
  static readonly DocumentsDownloadDocumentPath = '/api/documents/{recId}';

  /**
   * Download a document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsDownloadDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsDownloadDocument$Response(params: DocumentsDownloadDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDownloadDto>> {
    const obs = documentsDownloadDocument(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Download a document.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsDownloadDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsDownloadDocument(params: DocumentsDownloadDocument$Params, context?: HttpContext): Observable<DocumentDownloadDto> {
    const resp = this.documentsDownloadDocument$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DocumentDownloadDto>): DocumentDownloadDto => r.body)
    );
  }

}
